import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Subscription } from 'rxjs';
import { HttpResponse } from '../../../common/models/dto/http-response';
import { MessageService } from '../../../common/services/message.service';
import { ViewManagerService } from '../../../core/services/view-manager-service';
import { UserManager } from "../../services/user-manager";

declare var closeModal: any;
declare var openModal: any;
declare var exitFunction: any;
declare var logoutApp;

@Component({
  selector: 'div [notify-service]',
  templateUrl: 'notify.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class NotifyComponent implements OnInit, OnDestroy {
  message: HttpResponse;
  show: boolean = true;
  subscription: Subscription = null;
  subscriptionPerStampa: Subscription;

  constructor(private viewManager: ViewManagerService, private messageService: MessageService, private router: Router, private userManager: UserManager) {
    this.message = new HttpResponse();
    this.createServiceSubscription();
    // this.createServiceSubscriptionViewManager();
    this.subscriptionPerStampa = this.viewManager.ctxHeader.subscribe(res => this.show = res);
  }

  ngOnInit() {

  }

  private createServiceSubscription() {
    this.subscription = this.messageService.errorObservable.subscribe(resp => {
      console.log(resp);
      if (resp.status === 403 /*&& (resp.message.indexOf('No security context found') >= 0 ||
        resp.message.indexOf('Login failed') >= 0  || resp.error.indexOf('No security context found') >= 0 ||
      resp.error.indexOf('Login failed') >= 0 )*/) {
        this.viewManager.storeErrorMsg(resp.message);
        // this.userManager.clearUserLogged();
        this.userManager.clearUser();
        localStorage.removeItem('TLF_USER');
        // localStorage.removeItem('TLF_SDOMAIN');
        localStorage.removeItem('TLF_TENANT');
        // localStorage.removeItem('TLF_PRODUCT');
        localStorage.removeItem('token');
        // this.router.navigate([UrlSettingsCore.URL_LOGIN]);

        // logoutApp(UrlSettingsCore.URL_LOGOUT, UrlSettingsCore.URL_LOGIN);
        window.location.replace(window.location.protocol + '//' + window.location.host + window.location.pathname);
        // exitFunction();
      } else {
        openModal('notifyService');
        try {
          this.message = resp.json();
        } catch (e) {
          this.message = new HttpResponse();
          this.message.httpCode = resp.status.toString();
          this.message.returnCode = resp.statusText;
          if (resp.error) {
            this.message.koMessages = [resp.error];
          } else {
            this.message.returnCode = 'ERROR';
            this.message.koMessages = ['Impossibile contattare il server.'];
          }
        }
      } /*else {
          if (message.status === 403) {
            this.viewManager.storeErrorMsg(message);
            exitFunction();
        }
      }*/
    });
  }

  private createServiceSubscriptionViewManager() {
    this.subscription = this.viewManager.errorObservable.subscribe(message => {
      openModal('notifyService');
      this.message = new HttpResponse;
      this.message.httpCode = '';
      this.message.returnCode = 'ERROR';
      this.message.koMessages = [message];
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionPerStampa.unsubscribe();
  }

  close() {
    closeModal('notifyService');
  }
}

